import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Button, Box, Typography, CardContent} from "@mui/material";
import Card from "@mui/material/Card";
import Arrow from "../../../Assets/Svg/offersarrow.svg";
import {Styles} from "./styles";
import {showIconByServiceId} from "../../../helpers/showIconByServiceId";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../api_Routes";
import {useAuth} from "../../../AuthContext/AuthContext";
import {useSnackbar} from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";

const DetailsCard = ({data,id}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { auth } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar,closeSnackbar } = useSnackbar();
    const { showCenteredPopup } = useCenteredSnackbar();
    const handleButtonClick = async () => {
        if (!auth) {
            showCenteredPopup("please  login first ",
                { variant: "warning",
                    persist: true });
            // enqueueSnackbar("please  login first ", { variant: "warning",
            //     persist: true,
            //     action, });
            navigate("/login", { state: { from: location } });
        } else {
            await handleSubmit();
        }
    };

    const action = key => (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(key)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
    const handleSubmit = async () => {
        setIsLoading(true);

        const { response, message } = await Helper.Post({
            url: `${api_Routes.SmmDomain.Buy}/${id}`,
            hasToken: true,
        });

        if (response) {
            const invoice_id = response.data.uuid;

            navigate(`/DomainInvoice?invoice_id=${invoice_id}`);
        } else {
            showCenteredPopup(message || "An error occurred",
                { variant: "error",
                    persist: true });
            // enqueueSnackbar(message || "An error occurred", {
            //     variant: "error",
            //     persist: true,
            //     action,
            //     anchorOrigin: { vertical: "top", horizontal: "right" },
            // });
        }

        setIsLoading(false);
    };
    return (
        <Styles>
            <Box
                className="item-carosel"
                style={{padding: '0', width: '100%', justifyContent: "space-between"}}
                key={data.id}
                // onClick={() => handleNavigation(data.id)}
            >

                <div className="final-logo-container"
                     style={{alignContent: 'center', minHeight: '100px', margin: '0 20px'}}>
                    <label
                        style={{
                            fontSize: `16px`,
                            color: '#eca601',
                        }}
                    >
                        Domain :
                    </label>
                    <Typography
                        sx={{
                            fontSize: `17px`,
                            color: '#ffffff',
                        }}
                        className="final-logo"
                    >
                        {data.domain}
                    </Typography>
                </div>
                <div className="final-logo-container"
                     style={{alignContent: 'center', minHeight: '100px', margin: '0 20px'}}>
                    <label
                        style={{
                            fontSize: `16px`,
                            color: '#eca601',
                        }}
                    >
                        Description :
                    </label>
                    <Typography
                        sx={{
                            fontSize: `17px`,
                            color: '#ffffff',
                        }}
                        className="final-logo"
                    >
                        {data.description}
                    </Typography>

                </div>
                <div className="final-logo-container"
                     style={{alignContent: 'center', minHeight: '100px', margin: '0 20px'}}>
                    <label
                        style={{
                            fontSize: `16px`,
                            color: '#eca601',
                        }}
                    >
                        Price :
                    </label>
                    <Typography
                        sx={{
                            fontSize: `14px`,
                            color: '#ffffff',
                        }}
                        className="final-logo"
                    >
                        {data.price} $
                    </Typography>

                </div>
                <div className="final-logo-container"
                     style={{alignContent: 'center', minHeight: '100px', margin: '0 20px'}}>
                    <label
                        style={{
                            fontSize: `16px`,
                            color: '#eca601',
                        }}
                    >
                        Action :
                    </label>
                    <Button
                        style={{background: "#eca601",display:"block",color:"#000000"}}
                        onClick={handleButtonClick}
                    >
                        Buy Now
                    </Button>

                </div>

            </Box>
        </Styles>
    );
};

export default DetailsCard;
